'use strict';

angular.module('contentful').directive('cfAssetList', () => ({
  template: JST.asset_list(),
  restrict: 'A',
  controller: 'AssetListController'
}));



// WEBPACK FOOTER //
// ./src/javascripts/components/tabs/asset_list/asset_list_directive.js